export default __webpack_public_path__ + "static/media/img3.dca3da33.jpg";